export function range(to: number): number[]
{
    var numbers: number[] = [];
    for (var i = 0; i <= to; i++) {
       numbers.push(i);
    }
    return numbers;
}